<template>
    <el-dialog class="el-dialogs" :title="title" width="1100px" :close-on-click-modal="false"
               :visible.sync="visible">
        <el-form size="small" ref="searchForm" :disabled="disabled" :model="searchForm" :rules="rules"
                 label-width="100px">
            <el-form-item label="算法名称：" prop="name">
                <el-input v-model.trim="searchForm.name" maxlength="20"
                          placeholder="请输入算法名称(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="算法别名：" prop="alias">
                <el-input v-model.trim="searchForm.alias" maxlength="20"
                          placeholder="请输入算法别名(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="脱敏类型：" prop="type">
                <el-radio-group v-model="searchForm.type" @input="setZationType">
                    <el-radio label="0">字符型</el-radio>
                    <el-radio label="1">数值型</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="脱敏算法：" prop="desensitizationAlgorithm">
                <el-radio-group v-model="searchForm.desensitizationAlgorithm" @input="setAlgorithm">
                    <el-radio v-show="searchForm.type == 0" :label="'0'">掩码</el-radio>
                    <el-radio :label="'1'">字符替换</el-radio>
                    <el-radio v-show="searchForm.type == 1" :label="'2'">区间归一缩放</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-if="searchForm.desensitizationAlgorithm == 0" key="adsdg" label="算法参数：" prop="parame">
                <div class="flex_l_t">
                    <div>保留前</div>
                    <el-form-item label-width="0" prop="reserveBefore" style="width: 80px;">
                        <el-input v-model.trim="searchForm.reserveBefore" maxlength="4"
                                  @input="setBorrowDays('reserveBefore')"></el-input>
                    </el-form-item>
                    <div>个和后</div>
                    <el-form-item label-width="0" prop="reserveAfter" style="width: 80px;">
                        <el-input v-model.trim="searchForm.reserveAfter" maxlength="4"
                                  @input="setBorrowDays('reserveAfter')"></el-input>
                    </el-form-item>
                    <div>个，其它字符替换为：</div>
                    <el-form-item label-width="0" prop="content3" style="width: 160px;">
                        <el-input v-model.trim="searchForm.content3" maxlength="10"
                                  clearable></el-input>
                    </el-form-item>
                </div>
            </el-form-item>
            <el-form-item v-if="searchForm.desensitizationAlgorithm == 1" key="uiaduifhaudfh" label="替换字符：" prop="content1">
                <el-input v-model.trim="searchForm.content1" maxlength="10"
                          placeholder="请输入替换字符(限10字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item v-if="searchForm.desensitizationAlgorithm == 2" key="uihdu8uua" label="区间设置：" prop="qujianshexz">
                <div class="text_right">
                    <el-button type="primary" icon="el-icon-plus" @click="addInterval()">添加区间</el-button>
                </div>
            </el-form-item>
            <div class="tabClas" v-if="searchForm.desensitizationAlgorithm == 2" key="uihuyuhjhl">
                <el-table
                        :data="searchForm.intervals"
                        size="small" height="200px"
                        class="table" border
                        :header-cell-style="{ textAlign: 'center' }"
                        ref="multipleTable"
                >
                    <el-table-column prop="name" label="区间名称" width="180px">
                        <template slot-scope="{row}">
                            <div v-if="!row.edit">{{ row.intervalName }}</div>
                            <el-input v-else v-model.trim="row.intervalName" maxlength="10" size="mini"
                                      style="width: 150px;"
                                      placeholder="区间名称(限10字)"
                                      clearable></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="范围值" width="766px">
                        <template slot-scope="{row,$index}">
                            <div class="flex_b_c">
                                <div style="width: 20%">
                                    <div v-if="!row.edit">{{ row.initiate }}</div>
                                    <el-input v-else v-model.trim="row.initiate" maxlength="6" size="mini"
                                              style="width: 135px;"
                                              :disabled="judgeSymbol(row.finishConditions) || row.initiateConditions == 4 || row.initiateConditions == 5"
                                              @input="setBorrowDays2($index,'initiate')"
                                              placeholder="范围(0~999999)"
                                              clearable></el-input>
                                </div>
                                <div style="width: 20%">
                                    <div v-if="!row.edit">
                                        {{ $dictUtils.getDictLabel("hyposensiti_term", row.initiateConditions, '') }}
                                    </div>
                                    <el-select v-else v-model="row.initiateConditions" size="mini" style="width: 135px;"
                                               @change="selectInitiate(row)"
                                               :disabled="judgeSymbol(row.finishConditions)"
                                               placeholder="请选择">
                                        <el-option
                                                v-for="item in $dictUtils.getDictList('hyposensiti_term')"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div style="width: 20%" class="text_center">
                                    脱敏字段
                                </div>
                                <div style="width: 20%">
                                    <div v-if="!row.edit">
                                        {{ $dictUtils.getDictLabel("hyposensiti_term", row.finishConditions, '') }}
                                    </div>
                                    <el-select v-else v-model="row.finishConditions" size="mini" style="width: 135px;"
                                               @change="selectInitiate(row)"
                                               :disabled="judgeSymbol(row.initiateConditions)"
                                               placeholder="请选择">
                                        <el-option
                                                v-for="item in $dictUtils.getDictList('hyposensiti_term')"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div style="width: 20%">
                                    <div v-if="!row.edit">{{ row.finish }}</div>
                                    <el-input v-else v-model.trim="row.finish" maxlength="6" size="mini"
                                              style="width: 135px;"
                                              :disabled="judgeSymbol(row.initiateConditions) || row.finishConditions == 4 || row.finishConditions == 5"
                                              @input="setBorrowDays2($index,'finish')"
                                              placeholder="范围(0~999999)"
                                              clearable></el-input>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="100px" label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="deleteData(scope.row,scope.$index)">删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-form-item label="其它：归并成一项" label-width="140px" style="margin-top: 15px" prop="content2">
                    <el-input v-model.trim="searchForm.content2" maxlength="10" size="small" style="width: 200px;"
                              placeholder="其它(限10字)"
                              clearable></el-input>
                </el-form-item>
            </div>

            <el-form-item label="应用范围：" prop="yingYongf"></el-form-item>
            <div class="cueWord">（范围定义：
                <定义该规则权限适用于或不适用于哪些组
                        、角色、用户>）
            </div>
            <el-card class="box-card">
                <div class="flex_l_c newline">
                    <div>用户组：</div>
                    <el-button style="margin:0 10px" icon="el-icon-edit" type="text"
                               @click="addUserGroup(userGroupAllList,searchForm.department,'department')"></el-button>
                    <div v-for="(item,index) in searchForm.department" :key="index">
                        {{ item.departmentName ? item.departmentName : item.name }}
                        {{ (index + 1) == searchForm.department.length ? '' : '，' }}
                    </div>
                </div>
                <div class="flex_l_c newline magTops">
                    <div>角色：</div>
                    <el-button style="margin:0 10px" icon="el-icon-edit" type="text"
                               @click="addUserGroup(roleAllList,searchForm.role,'role')"></el-button>
                    <div v-for="(item,index) in searchForm.role" :key="index">
                        {{ item.name }} {{ (index + 1) == searchForm.role.length ? '' : '，' }}
                    </div>
                </div>
                <div class="flex_l_c newline magTops">
                    <div>用户：</div>
                    <el-button style="margin:0 10px" icon="el-icon-edit" type="text"
                               @click="addUserGroup(userAllList,searchForm.user,'user')"></el-button>
                    <div v-for="(item,index) in searchForm.user" :key="index">
                        {{ item.name }} {{ (index + 1) == searchForm.user.length ? '' : '，' }}
                    </div>
                </div>

                <div class="magTops">
                    <el-radio v-model="searchForm.applicable" label="0">适用于此范围</el-radio>
                    <el-radio v-model="searchForm.applicable" label="1">不适用于此范围</el-radio>
                </div>
            </el-card>
            <el-form-item label="应用于：" prop="applyTo" class="magTops">
                <el-checkbox-group v-model="searchForm.applyTo">
                    <el-checkbox label="1">浏览</el-checkbox>
                    <el-checkbox label="2">导出</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="禁用：" prop="switchType">
                <el-checkbox v-model="searchForm.switchType" true-label="1" false-label="0">禁用</el-checkbox>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" v-show="!disabled" type="primary" @click="doSubmit()" v-noMoreClick>确定</el-button>
            <el-button size="small" v-show="disabled" @click="visible = false">关闭</el-button>
        </div>
        <add-scope ref="addScope" @selectedData="selectedData"></add-scope>
    </el-dialog>
</template>

<script>
import AddScope from "@/views/modules/sys/desensitize/addScope.vue";

export default {
    name: "addDesensitize",
    components: {AddScope},
    data() {
        return {
            title: '新建脱敏规则',
            visible: false,
            searchForm: {
                id: '',
                name: '',
                alias: '',
                type: '0',
                desensitizationAlgorithm: '0',

                reserveBefore: '',
                reserveAfter: '',
                content: '',
                content1: '',
                content2: '',
                content3: '',

                intervalSettingList: [],

                department: [],
                role: [],
                user: [],
                applicable: '0',

                applyTo: ['1'],
                browseFlag: 1, //浏览（0开启；1关闭）
                deriveFlag: 1, //导出（0开启；1关闭）

                switchType: '0', //（禁用0开启；1关闭）

                intervals: [],

                parame: '叠甲',
                yingYongf: '叠甲',
                qujianshexz: '叠甲',
            },
            rules: {
                name: [
                    {required: true, message: '请输入算法名称', trigger: 'blur'},
                ],
                desensitizationAlgorithm: [
                    {required: true, message: '请选择脱敏算法', trigger: 'change'},
                ],
                applyTo: [
                    {type: 'array', required: true, message: '请选择应用于哪些功能', trigger: 'change'}
                ],
                reserveBefore: [
                    {required: true, message: '请输入保留前', trigger: 'blur'},
                ],
                reserveAfter: [
                    {required: true, message: '请输入保留后', trigger: 'blur'},
                ],
                content: [
                    {required: true, message: '请输入替换为', trigger: 'blur'},
                ],
                content1: [
                    {required: true, message: '请输入替换为', trigger: 'blur'},
                ],
                content2: [
                    {required: true, message: '请输入替换为', trigger: 'blur'},
                ],
                content3: [
                    {required: true, message: '请输入替换为', trigger: 'blur'},
                ],


                parame: [
                    {required: true, message: '请输入算法参数', trigger: 'blur'},
                ],
                yingYongf: [
                    {required: true, message: '请输入算法参数', trigger: 'blur'},
                ],
                qujianshexz: [
                    {required: true, message: '请输入算法参数', trigger: 'blur'},
                ],
            },

            userGroupAllList: [],
            roleAllList: [],
            userAllList: [],

            fieldList: [],//脱敏字段
            disabled: false,
        }
    },

    methods: {
        //typeName see查看 edit编辑 add新增
        init(typeName, row) {
            this.getOtherData()
            this.disabled = false
            this.searchForm.id = ''
            if (typeName == 'add') {
                this.title = '新建脱敏规则'
            }
            if (typeName == 'edit') {
                this.title = '编辑脱敏规则'
                this.getDetail(row.id)
            }
            if (typeName == 'see') {
                this.title = '查看脱敏规则'
                this.disabled = true
                this.getDetail(row.id)
            }
            this.visible = true
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields()
                this.searchForm.department = []
                this.searchForm.role = []
                this.searchForm.user = []
                this.searchForm.switchType = '0'
                this.searchForm.intervals = []
                this.searchForm.reserveBefore = ''
                this.searchForm.reserveAfter = ''
                this.searchForm.content = ''
                this.searchForm.content1 = ''
                this.searchForm.content2 = ''
                this.searchForm.content3 = ''
                this.searchForm.applicable = '0'
            })
        },

        getOtherData(){
            this.$axios(this.api.user.getEnabledSysDepartment, {}, 'post').then(res => {
                if (res.status) {
                    this.userGroupAllList = res.data
                }
            })
            this.$axios(this.api.user.sysroleQueryAll, {
                logicType:0,
            }).then(data => {
                if (data && data.status) {
                    this.roleAllList = data.data
                }
            })
            this.$axios(this.api.user.getSysUserByName, {
                logicType:0,
            }).then(data => {
                if (data && data.status) {
                    this.userAllList = data.data
                }
            })
        },

        getDetail(id) {
            this.$axios(this.api.metadata.releasesDesensitizationGetById + id).then(data => {
                if (data && data.status) {
                    Object.keys(this.searchForm).forEach(key => {
                        this.searchForm[key] = data.data[key]
                    })
                    if(this.searchForm.desensitizationAlgorithm == 1){
                        this.searchForm.content1 = this.searchForm.content
                    }
                    if(this.searchForm.desensitizationAlgorithm == 2){
                        this.searchForm.content2 = this.searchForm.content
                    }
                    if(this.searchForm.desensitizationAlgorithm == 0){
                        this.searchForm.content3 = this.searchForm.content
                    }
                    this.searchForm.parame = '叠甲'
                    this.searchForm.yingYongf = '叠甲'
                    this.searchForm.qujianshexz = '叠甲'

                    this.searchForm.applyTo = []
                    if (data.data.browseFlag == 0) {
                        this.searchForm.applyTo.push('1')
                    }
                    if (data.data.deriveFlag == 0) {
                        this.searchForm.applyTo.push('2')
                    }

                    this.searchForm.department = data.data.departmentList || []
                    this.searchForm.department.forEach(item => {
                        this.$set(item, 'departmentName', item.name)
                    })
                    this.searchForm.role = data.data.roleList || []
                    this.searchForm.user = data.data.userList || []

                    if (this.title == '编辑脱敏规则') {
                        this.searchForm.intervals.forEach((item) => {
                            this.$set(item, 'edit', true)
                        })
                    }
                }
            })
        },

        //脱敏算法的切换
        setAlgorithm() {
            if (this.searchForm.desensitizationAlgorithm == 0) {
                this.searchForm.content = ''
                this.searchForm.intervals = []
                this.$delete(this.rules, 'content')
            }
            if (this.searchForm.desensitizationAlgorithm == 1) {
                this.searchForm.reserveBefore = ''
                this.searchForm.reserveAfter = ''
                this.searchForm.content = ''
                this.searchForm.intervals = []
                this.$delete(this.rules, 'content')
            }
            if (this.searchForm.desensitizationAlgorithm == 2) {
                this.searchForm.reserveBefore = ''
                this.searchForm.reserveAfter = ''
                this.searchForm.content = ''
                this.$set(this.rules, 'content', [
                    {required: true, message: '请输入其它', trigger: 'blur'},
                ],)
                this.$nextTick(() => {
                    this.$refs.searchForm.clearValidate()

                })
            }
        },

        //脱敏类型切换
        setZationType() {
            if (this.searchForm.type == 0) {
                if (this.searchForm.desensitizationAlgorithm == 2) {
                    this.searchForm.desensitizationAlgorithm = '0'
                }
            } else {
                if (this.searchForm.desensitizationAlgorithm == 0) {
                    this.searchForm.desensitizationAlgorithm = '1'
                }
            }
            this.setAlgorithm()
        },

        //只能输入大于0的正整数
        setBorrowDays(formName) {
            this.searchForm[formName] = this.searchForm[formName].replace(/[^0-9]/g, "")
            if (this.searchForm[formName] == '') {
                this.searchForm[formName] = '0'
            }
        },

        //添加应用范围 allList所有数据 selectList已经选中的数据 selectListName选中数据存贮的名字
        addUserGroup(allList, selectList, selectListName) {
            this.$refs.addScope.init(allList, selectList, selectListName)
        },

        //选中后的数据
        selectedData(data) {
            this.searchForm[data.selectListName] = data.selectData
        },

        //添加区间
        addInterval() {
            this.searchForm.intervals.push({
                edit: true,
                intervalName: '',
                initiate: '',
                initiateConditions: '',
                desensitizationId: this.searchForm.id,
                finishConditions: '',
                finish: '',
            })
        },

        //只能输入大于0的正整数
        setBorrowDays2(index, formName) {
            this.searchForm.intervals[index][formName] = this.searchForm.intervals[index][formName].replace(/[^0-9]/g, "")
        },

        //选择范围符号
        selectInitiate(row) {
            if (this.judgeSymbol(row.initiateConditions)) {
                row.finishConditions = ''
                row.finish = ''
                if (row.initiateConditions == 4 || row.initiateConditions == 5) {
                    row.initiate = ''
                }
            }
            if (this.judgeSymbol(row.finishConditions)) {
                row.initiateConditions = ''
                row.initiate = ''
                if (row.initiateConditions == 4 || row.initiateConditions == 5) {
                    row.finish = ''
                }
            }
        },

        //判断符号是否是 大于等于(2) 小于等于(2)  true 不是 false 是
        judgeSymbol(value) {
            if (value === '') {
                return false
            }
            if (value != 2 && value != 3) {
                return true
            } else {
                return false
            }
        },

        //删除区间
        deleteData(row, index) {
            this.$confirm(`确认删除所选信息？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.searchForm.intervals.splice(index, 1)
            })
        },


        doSubmit() {
            if (this.searchForm.desensitizationAlgorithm == 2){
                if (!this.searchForm.intervals.length){
                    this.$message.error('请添加区间')
                    return
                }
            }
            if (!this.searchForm.department.length && !this.searchForm.role.length && !this.searchForm.user.length){
                this.$message.error('请选择应用范围')
                return
            }
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    this.searchForm.browseFlag = 1
                    this.searchForm.deriveFlag = 1
                    this.searchForm.applyTo.forEach(item => {
                        if (item == 1) {
                            this.searchForm.browseFlag = 0
                        }
                        if (item == 2) {
                            this.searchForm.deriveFlag = 0
                        }
                    })
                    let saveData = JSON.parse(JSON.stringify(this.searchForm))
                    if (saveData.content1 || saveData.content1 == 0 ){
                        saveData.content = saveData.content1
                    }
                    if (saveData.content2 || saveData.content2 == 0){
                        saveData.content = saveData.content2
                    }
                    if (saveData.content3 || saveData.content3 == 0){
                        saveData.content = saveData.content3
                    }
                    saveData.department = saveData.department.map(item => {
                        return item.id
                    }).join(',')
                    saveData.role = saveData.role.map(item => {
                        return item.id
                    }).join(',')
                    saveData.user = saveData.user.map(item => {
                        return item.id
                    }).join(',')
                    if (saveData.id) {
                        this.$axios(this.api.metadata.releasesDesensitizationUpdateById, saveData, 'put').then(data => {
                            if (data && data.status) {
                                this.$message.success('编辑成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        this.$axios(this.api.metadata.releasesDesensitizationSave, saveData, 'post').then(data => {
                            if (data && data.status) {
                                this.$message.success('保存成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            })
        },

    },
}
</script>

<style lang="scss" scoped>
.el-dialogs > > > .el-dialog__body {
  height: auto !important;
}

.cueWord {
  margin-top: -18px;
  margin-left: 15px;
  font-size: 12px;
  color: #C0C4CC;
}

.box-card {
  margin-top: 10px;
  margin-left: 15px;
  height: auto !important;

  &::v-deep .el-card__body {
    padding: 10px !important;
    font-size: 14px;
  }

  .newline {
    flex-wrap: wrap;
  }
}

.magTops {
  margin-top: 15px;
}

.tabClas {
  margin-left: 15px;
  box-sizing: border-box;
}
</style>